module.exports = __webpack_public_path__ + "static/img/til95.3118643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til95.png
// module id = o7DS
// module chunks = 1